// Deep links into phoniq-insight (the search → company story experience).
// The map is the daily overview; Insight is the deep dive for one operator or
// brand group. We link out (no embed) so the two apps stay decoupled.
//
// Override the base via VITE_INSIGHT_BASE when running both locally.

const INSIGHT_BASE: string =
  (import.meta.env.VITE_INSIGHT_BASE as string | undefined) ?? "https://iq.phoniq.no";

/** Company (single farm_operator) view: /c/{slug}. */
export function insightCompanyUrl(slug: string): string {
  return `${INSIGHT_BASE}/c/${encodeURIComponent(slug)}`;
}

/** Brand-group (aggregated entities) view: /g/{slug}. */
export function insightGroupUrl(slug: string): string {
  return `${INSIGHT_BASE}/g/${encodeURIComponent(slug)}`;
}

/** Single-vessel view: /v/{mmsi}. */
export function insightVesselUrl(mmsi: number): string {
  return `${INSIGHT_BASE}/v/${encodeURIComponent(String(mmsi))}`;
}

/** Single-location (site) view: /l/{locality_no}. */
export function insightLocationUrl(localityNo: number): string {
  return `${INSIGHT_BASE}/l/${encodeURIComponent(String(localityNo))}`;
}
